// extracted by mini-css-extract-plugin
module.exports = {"textPerson":"SettingsDialog_textPerson__3FihV"};